module.exports = __webpack_public_path__ + "img/canvasMenu9.e9ab384b.svg";